<template>
    <ADropdown
        v-model="locale"
        :items="dropdownOptions"
        name-field="label"
        key-field="value"
        @onChange="handleChangeLocale"
        @onOpenChange="handleOpenClose"
    >
        <template #select-option="{ option }">
            <div class="dropdown__inner-block">
                <svg-icon
                    original
                    :name="`locales/${option.value}`"
                    class="dropdown__icon"
                />
                <span  class="dropdown__text">
                    {{ option.label }}
                </span>
            </div>
        </template>
    </ADropdown>
</template>

<script>
import {
    mapState,
    mapActions,
    mapGetters 
} from "vuex";

import ADropdown from '../../atoms/a-dropdown/a-dropdown';

import {
    SHOW_OVERLAY,
    RESTORE_LOCALE
} from "@/utils/constants/bus-events-constants";

export default {
    name: 'OLanguageSelector',
    components: {
        ADropdown
    },
    data() {
        return {
            locale: this.$i18n.locale()
        }
    },
    computed: {
        ...mapState({
            languages: state => state.map.meta.languages,
            defaultLocale: state => state.map.meta.language
        }),
        ...mapGetters([
            'getActiveLocale'
        ]),
        dropdownOptions() {
            const result = [];
            this.languages.forEach(item => {
                result.push({
                    value: item,
                    label: this.$t(`ui.language-${item}`)
                })
            });
            return result;
        },
    },
    mounted() {
        this.locale = this.getActiveLocale;
        this.initEventsListeners();
    },
    beforeDestroy() {
        this.deactivateEventsListeners();
    },
    methods: {
        ...mapActions([
            'changeLocale'
        ]),
        initEventsListeners() {
            this.$bus.$on(RESTORE_LOCALE, this.restoreLocale);
        },
        deactivateEventsListeners() {
            this.$bus.$off(RESTORE_LOCALE, this.restoreLocale);
        },
        handleChangeLocale(locale) {
            this.changeLocale(locale);
        },
        handleOpenClose(val) {
            this.$bus.$emit(SHOW_OVERLAY, val);
        },
        restoreLocale() {
            this.handleChangeLocale(this.defaultLocale);
            this.locale = this.defaultLocale;
        }
    }
}
</script>